import Vue from 'vue'
import Router from 'vue-router'
import * as firebase from "firebase/app";
// Pages 
import Login from '@/pages/users/login'
import Register from '@/pages/users/register'
import Home from '@/pages/home/index'
import Settings from '@/pages/settings/index'
import NotFound from '@/components/NotFound'
import DeleteAccount from '@/pages/settings/deleteaccount.vue'
import CustomInterest from '@/pages/interest/index'

Vue.use(Router)

let router = new Router({
    mode: "hash",
    history: false,
    routes: [
        /**
         * Home
         */
        {
            path: '/login',
            name: 'Login',
            component: Login
        },
        {
            path: '/register',
            name: 'Register',
            component: Register,
            meta: {
                noRedirect: true
            }
        },        
        {
            path: '/settings',
            name: 'Settings',
            component: Settings,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/customize-interest',
            name: 'Customize-Interest',
            component: CustomInterest,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/deleteaccount',
            name: 'Account Delete',
            component: DeleteAccount,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/',
            name: 'Home',
            component: Home,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '*',
            name: 'NotFound',
            component: NotFound
        }
    ]
})


router.beforeEach((to, from, next) => {
    firebase.auth().onAuthStateChanged((user) => {
        const currentUser = (user)?user:'';
        const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
        const noRedirect = to.matched.some(record => record.meta.noRedirect);

        if (requiresAuth && !currentUser) next('login');
        // else if (!requiresAuth && currentUser) next('/');
        else next();

    })
});

export default router



// WEBPACK FOOTER //
// ./src/router/index.js